function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#DCD8BF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.104 27.004c-.405-5.699-5.153-10.69-11.555-11.366-6.402-.675-12.081 3.223-13.665 8.717-1.585 5.495-1.794 10.814.304 13.322 2.097 2.51 6.28 4.033 10.571 4.48 4.293.453 8.695-.172 11.269-2.189 2.58-2.01 3.482-7.265 3.076-12.964z",
  fill: "#F7F3E1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.164 28.626s-2.072-.733-3.222.959c-.905 1.331-.572 4.195 1.754 5.347 1.992.99 2.773.36 2.773.36l-1.305-6.666zM38.918 31.35s2.18-.284 2.946 1.61c.606 1.491-.319 4.224-2.83 4.862-2.156.547-2.791-.227-2.791-.227l2.675-6.245z",
  fill: "#F7F3E1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.608 29.356s-2.616 1.794-4.457-.64c-1.609-2.127-1.91-5.87-2.235-9.574-.325-3.702-3.117-7.352-7.675-6.597-3.232.536-4.69 2.078-5.329 3.147-.113-.019-.227-.037-.347-.055-6.402-.675-12.081 3.216-13.666 8.704a34.929 34.929 0 00-.947 4.221 3.941 3.941 0 00-.415-.077c.147.023.61.116 1.042.542l.525.518 1.006-4.04s1.75-.565 4.987-.283c.376-1.902.97-3.595 2.524-4.807 0 0-.785 1.336-1.146 4.764 4.372-.101 8.81 1.114 8.81 1.114s.158-2.37.878-3.972c.206 2.84.24 2.58.478 4.274 3.376.583 5.128 1.26 5.128 1.26s.515.75.285 4.075c1.643-2.096 4.224-.81 4.802 1.13a3.603 3.603 0 01-.072 2.278c.022-.06.052-.116.068-.17 6.586.577 5.756-5.812 5.756-5.812z",
  fill: "#938666"
});

var SvgEmptyFriend = function SvgEmptyFriend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyFriend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-friend.8827fa2e.svg";
export { ForwardRef as ReactComponent };